import { render, staticRenderFns } from "./HelpdeskTickets.vue?vue&type=template&id=08edd1cf&scoped=true"
import script from "./HelpdeskTickets.vue?vue&type=script&lang=js"
export * from "./HelpdeskTickets.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTickets.vue?vue&type=style&index=0&id=08edd1cf&prod&scoped=true&lang=css"
import style1 from "./HelpdeskTickets.vue?vue&type=style&index=1&id=08edd1cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edd1cf",
  null
  
)

export default component.exports